import {ModuleConfiguration} from "../router/model/UserPermission";
import {ActionStatusModuleName, CampaignsServiceModuleName} from "../utils/names/optionalModuleNames";

export const CampaignsServiceModuleConfiguration = new ModuleConfiguration(CampaignsServiceModuleName,
    [ActionStatusModuleName]);
